<ng-container *ngIf="campaignBanner">
  <div class="campaign-banner-container" *ngIf="campaignBanner && showBanner">
    <div class="campaign-image-content">
      <img
        class="desktop-image"
        [src]="campaignBanner.desktopImageUrl"
        alt="" />
      <img class="mobile-image" [src]="campaignBanner.mobileImageUrl" alt="" />
    </div>
    <div class="text-content-container">
      <h3 class="title" [innerHTML]="campaignBanner.title"></h3>
      <p class="main-content" [innerHTML]="campaignBanner.mainContent"></p>
      <p class="link" [innerHTML]="campaignBanner.link"></p>
      <p class="sub-content" [innerHTML]="campaignBanner.subContent"></p>
    </div>
  </div>
</ng-container>
